import { SubmitHandler } from 'react-hook-form'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useCookies } from 'react-cookie'
import { ContactForm, IContactFormData } from './widgets/audit-request-form/AuditRequestForm'
import { useContactMutation } from '../../app/api'
import { AuthTemplate } from '../../widgets/utility/AuthTemplate'
import { BpButton } from '../../shared/components/buttons/bp-button/BpButton'

export const AuditRequest = () => {
  const { t } = useTranslation()
  const [triggerRequestContact, { isLoading, isSuccess }] = useContactMutation()
  const [cookies] = useCookies()

  const handleSubmit: SubmitHandler<IContactFormData> = (formData: IContactFormData) => {
    const filteredCookies = Object.fromEntries(
      Object.entries(cookies).filter(([key]) =>
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].includes(key),
      ),
    )

    const [name, surname] = formData.name.split(' ')

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'sent_request_demo',
      ecommerce: {
        event: 'sent_request_demo',
        ecommerce: {
          email: formData.email,
          name,
          surname: surname || '',
          company: formData.company,
        },
      },
    })

    triggerRequestContact({ body: { ...formData, ...filteredCookies } })
  }

  return (
    <>
      <Helmet>
        <title>Get a free demo and start using our tool today | {t('project.name')}</title>
        <meta
          content='Stay ahead of your competitors and cheating affiliates with our AI powered protection & tracking software'
          name='description'
        />
      </Helmet>
      <AuthTemplate
        form={
          isSuccess ? (
            <div className='flex flex-col items-start gap-[24px] md:w-[406px] md:gap-[40px] md:pt-[182px]'>
              <h1 className='text-focus-500'>{t('pages.audit.thankForRequest')}</h1>
              <p className='text-[15px] leading-[24px] text-focus-500 md:text-[24px] md:leading-[36px]'>
                {t('pages.audit.requestSentSuccessfully')}
              </p>
              <a href={t('project.landing')}>
                <BpButton className={'uppercase'} theme='outline' type='button'>
                  {t('pages.audit.buttons.goToHomepage')}
                </BpButton>
              </a>
            </div>
          ) : (
            <ContactForm isFetching={isLoading} submitHandler={handleSubmit} />
          )
        }
      >
        <div className={'flex h-full items-center justify-center px-[16px]'}>
          <div className={'flex max-w-[430px] flex-col'}>
            <div>
              <h1 className='pb-[16px] text-[48px]'>{t('pages.audit.reviewYourBranded')}</h1>
              <p className='mb-[32px] text-[24px] leading-[36px] text-white'>
                {t('pages.audit.requestFreeAudit')}
              </p>
            </div>
          </div>
        </div>
      </AuthTemplate>
    </>
  )
}
